import { TokensPayload } from '@/types/tokensPayload'

type getCurrentDateInMs = () => number
type getCookie = (name:string) => string | undefined

const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))

  return JSON.parse(jsonPayload)
}

export const getValidSession = (getCurrentDateInMs: getCurrentDateInMs, getCookie: getCookie) => (): TokensPayload | false => {
  try {
    const tokens = {
      AccessToken: getCookie('SSOLMSAccess') as string,
      IdToken: getCookie('SSOLMSID') as string
    }

    if (!tokens.AccessToken || !tokens.IdToken) return false

    const payload = parseJwt(tokens.AccessToken)
    const expInMs = payload.exp * 1000
    const isValid = expInMs > getCurrentDateInMs()
    return isValid ? tokens : false
  } catch (error) {
    return false
  }
}
